import SvgIcon from '@/pages/home/components/SvgIcon';
import React from 'react';
import { Button, Icon } from 'tea-component';

export default function Download(props: any) {
  const { state, disabled = false, event } = props;
  const { defaultParams, ...otherProps } = props;
  return (
    <Button
      type="icon"
      className="dbo-downloadbutton ns-btn--icon"
      disabled={disabled}
      {...event}
      {...otherProps}
    >
      {state == 'loading' ? (
        <Icon type="loading" />
      ) : (
        <SvgIcon type="download" />
      )}
    </Button>
  );
}
